var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlineCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000976562,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#EFEFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2592 19.5106H8.97683C7.99357 19.5106 7.19438 18.7116 7.19438 17.7283V10.2745C7.19438 9.29126 7.99357 8.49219 8.97683 8.49219H18.3749C19.3582 8.49219 20.1574 9.29126 20.1574 10.2745V14.4227C20.1574 14.6911 19.9396 14.9089 19.6713 14.9089C19.4029 14.9089 19.1852 14.6917 19.1852 14.4227V10.2745C19.1852 9.82792 18.8215 9.46441 18.3749 9.46441H8.97683C8.53024 9.46441 8.1666 9.82792 8.1666 10.2745V17.7283C8.1666 18.1749 8.53024 18.5384 8.97683 18.5384H14.2592C14.5275 18.5384 14.7453 18.7562 14.7453 19.0245C14.7453 19.2929 14.5275 19.5106 14.2592 19.5106Z",
    fill: "#6F767E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6714 12.0562H7.68058C7.41225 12.0562 7.19447 11.8384 7.19447 11.5701C7.19447 11.3018 7.41225 11.084 7.68058 11.084H19.6714C19.9397 11.084 20.1575 11.3018 20.1575 11.5701C20.1575 11.8384 19.9397 12.0562 19.6714 12.0562Z",
    fill: "#6F767E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2728 10.7601C10.0044 10.7601 9.78667 10.5423 9.78667 10.274V7.68142C9.78667 7.41309 10.0044 7.19531 10.2728 7.19531C10.5411 7.19531 10.7589 7.41309 10.7589 7.68142V10.274C10.7589 10.5423 10.5411 10.7601 10.2728 10.7601Z",
    fill: "#6F767E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0786 10.7601C16.8103 10.7601 16.5925 10.5423 16.5925 10.274V7.68142C16.5925 7.41309 16.8103 7.19531 17.0786 7.19531C17.347 7.19531 17.5648 7.41309 17.5648 7.68142V10.274C17.5648 10.5423 17.347 10.7601 17.0786 10.7601Z",
    fill: "#6F767E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5369 20.8065C18.2686 20.8065 18.0508 20.5888 18.0508 20.3204V16.7556C18.0508 16.4873 18.2686 16.2695 18.5369 16.2695C18.8053 16.2695 19.023 16.4873 19.023 16.7556V20.3204C19.023 20.5888 18.8053 20.8065 18.5369 20.8065Z",
    fill: "#6F767E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3194 19.024H16.7546C16.4863 19.024 16.2685 18.8062 16.2685 18.5379C16.2685 18.2695 16.4863 18.0518 16.7546 18.0518H20.3194C20.5877 18.0518 20.8055 18.2695 20.8055 18.5379C20.8055 18.8062 20.5877 19.024 20.3194 19.024Z",
    fill: "#6F767E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineCalendar);
export default __webpack_public_path__ + "static/media/OutlineCalendar.fc0528ec87c86483c2f155dba6c76739.svg";
export { ForwardRef as ReactComponent };